__turbopack_context__.v({
  "excludedStatic": "CallInsightToggle-module__b1SDsW__excludedStatic",
  "iconButton": "CallInsightToggle-module__b1SDsW__iconButton",
  "recounting": "CallInsightToggle-module__b1SDsW__recounting",
});
